module.exports = __webpack_public_path__ + "img/batch-upload.a76f1aab.svg";